import DOMPurify from 'isomorphic-dompurify';
const { marked } = require('marked');

export default function parseMarkdown(markdown) {
  return marked.parse(DOMPurify.sanitize(markdown));
}
